import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./HeroSection.css";
import ModernSearchBar from "./ModernSearchBar";
import { FaBriefcase, FaArrowRight } from "react-icons/fa";
import { SITELINK_PAGES } from "../../../constants/seo";

const HERO_STATS = [
  { value: "2,500+", label: "Active Jobs" },
  { value: "800+", label: "Top Recruiters" },
  { value: "400+", label: "Leading Brands" },
];

const HeroSection = () => {
  const [role, setRole] = useState("");

  useEffect(() => {
    setRole(localStorage.getItem("role") || "");
  }, []);

  return (
    <>
      {/* Main Hero Section */}
      <section className="modern-hero">
        <div className="modern-hero-container">
          <div className="modern-hero-content">
            {/* Main Heading */}
            <h1 className="modern-hero-title">
              Find Your Dream <span className="modern-hero-highlight">CA, CS & CMA</span> Job Today
            </h1>
            <p className="modern-hero-subtitle">
              India's first recruitment portal exclusively for CA, CS, and CMA professionals. 
              Discover opportunities from top companies.
            </p>

            {/* Modern Search Bar */}
            <ModernSearchBar variant="hero" />

            {/* Quick Action Links */}
            <div className="modern-hero-quick-actions">
              {SITELINK_PAGES.slice(0, 6).map((item) => (
                <Link key={item.path} to={item.path} className="modern-hero-quick-action">
                  {item.path === "/post-job" ? <FaBriefcase /> : null}
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Stats */}
            <div className="modern-hero-stats">
              {HERO_STATS.map((stat) => (
                <div key={stat.label} className="modern-hero-stat">
                  <span className="modern-hero-stat-number">{stat.value}</span>
                  <span className="modern-hero-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Employer CTA Section */}
      {role !== "Jobseeker" && (
        <section className="modern-employer-cta">
          <div className="modern-employer-cta-container">
            <div className="modern-employer-cta-content">
              <h2 className="modern-employer-cta-title">
                Looking to Hire CA Professionals?
              </h2>
              <p className="modern-employer-cta-text">
                Post jobs and connect with qualified CA, CS, and CMA professionals.
              </p>
              <Link to="/post-job" className="modern-employer-cta-btn">
                Post a Job
                <FaArrowRight />
              </Link>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default HeroSection;
